import {GoogleMapsDot} from 'components/icons/GoogleMapsDot';
import React from 'react';
import {ResidenceType} from 'features/search/filters/enums';

import './_markerDot.scss';
import {SearchResult} from "features/search/types";

interface Props {
    lat?: number;
    lng?: number;
    onClick?: () => void;
    residenceType?: ResidenceType;
    stage?: SearchResult;
    isCluster?: boolean;
}

export const MarkerDot: React.FunctionComponent<Props> = ({onClick, residenceType, stage, isCluster}) => {

    if(!stage && !isCluster) return null;

    return (
        <GoogleMapsDot stageStatus={stage && stage.stageStatus} residenceType={residenceType} onClick={onClick} />
    );
};
